// extracted by mini-css-extract-plugin
module.exports = {"root":"OaRd42hGur2vvhzgTK1_","cardContent":"tVMBLGdqt7ph1LkTg5tP"};